import {Component, Input, OnInit} from '@angular/core';
import {TColorSystem} from "../../../interfaces/system.interface";

@Component({
  selector: 'badge-exist',
  templateUrl: './badge-exist.component.html'
})
export class BadgeExistComponent implements OnInit {

  @Input() item: boolean;
  @Input() existText: string = '';
  @Input() notExistText: string = 'No';
  @Input() existColor: TColorSystem = 'secondary';
  @Input() notExistColor: TColorSystem = 'dark';

  constructor() { }

  ngOnInit(): void {
  }

}
